import React from "react";

function loader() {
  return <div>loader</div>;
}

export default loader;
